import Immutable from 'immutable';

import type ErrorData from 'sharedreact/data/ErrorData';
import SortOrder from 'sharedreact/data/SortOrder';
import UpdateAction from 'sharedreact/data/UpdateAction';
import AppDispatcher from 'sharedreact/dispatcher/AppDispatcher';

import ViewSessionsConnection from 'workspaces/launcher/connections/ViewSessionsConnection';
import ViewSessionsConstants from 'workspaces/launcher/constants/ViewSessionsConstants';
import ViewSession from 'workspaces/launcher/data/ViewSession';

function _fetchSuccess (items: Immutable.List<ViewSession>) {
  AppDispatcher.dispatch({
    actionType: ViewSessionsConstants.GET_SUCCESS,
    items: items,
    logLevel: 'debug'
  });
}

function _fetchFailure (error: ErrorData) {
  AppDispatcher.dispatch({
    actionType: ViewSessionsConstants.GET_FAIL,
    error: error,
    logLevel: 'debug'
  });
}

function fetch () {
  AppDispatcher.dispatch({
    actionType: ViewSessionsConstants.GET,
    logLevel: 'debug'
  });

  ViewSessionsConnection.fetch(_fetchSuccess, _fetchFailure);
}

function _fetchMaxSessionsSuccess (maxSessions: number) {
  AppDispatcher.dispatch({
    actionType: ViewSessionsConstants.UPDATE_MAXSESSIONS,
    maxSessions: maxSessions,
    logLevel: 'debug'
  });
}

function fetchMaxSessions () {
  ViewSessionsConnection.fetchMaxSessions(_fetchMaxSessionsSuccess, _fetchFailure);
}

function setSortOrder (sortOrder: SortOrder): void {
  AppDispatcher.dispatch({
    actionType: ViewSessionsConstants.SET_SORTORDER,
    sortOrder: sortOrder,
    logLevel: 'trace'
  });
}

function update (actions: Immutable.List<UpdateAction>) {
  AppDispatcher.dispatch({
    actionType: ViewSessionsConstants.UPDATE,
    actions: actions,
    logLevel: 'debug'
  });
}

const ViewSessionsActions = {
  fetch,
  fetchMaxSessions,
  setSortOrder,
  update
};

export default ViewSessionsActions;
